__turbopack_context__.v({
  "root": "switch-module-scss-module__iHV5ia__root",
  "thumb": "switch-module-scss-module__iHV5ia__thumb",
  "wrapper": "switch-module-scss-module__iHV5ia__wrapper",
});
